<div class="team-wrapper">
  <ngx-glide [showArrows]="false" type="carousel" [rewind]="true" [showBullets]="true" [perView]="3" [gap]="20"
    [breakpoints]="breakpoints" [bound]="true" arrowLeftLabel="" arrowRightLabel="" [autoplay]="3000">
      <div class="cards" *ngFor="let item of meetTeam">
        <img [loading]="lazy" class="employee" [attr.data-src]="item.imgClass"/>
        <div class="name">{{item.name}}</div>
        <div class="designation">{{item.designation}}</div>
        <div class="descriptn">{{item.description}}</div>
      </div>
  </ngx-glide>
</div>
